let loginDuration : number = 4;

export class LogoutPopupService {

  public static setLoginDuration(duration : number) {
    loginDuration = duration;
  }

  public static getLoginDuration() {
      return  loginDuration;
  }
}